export const contractImages = {
  contract_document: 'assets/img/linear-notes-document.svg',
  close_icon: 'assets/img/Close_square.svg',
  contract_1_icon: 'assets/menu-customisation-icons/Contracts/contract1.svg',
  contract_2_icon: 'assets/menu-customisation-icons/Contracts/contract2.svg',
  contract_3_icon: 'assets/menu-customisation-icons/Contracts/contract3.svg',
  contract_4_icon: 'assets/menu-customisation-icons/Contracts/contract4.svg',
  contract_5_icon: 'assets/menu-customisation-icons/Contracts/contract5.svg',
  contract_6_icon: 'assets/menu-customisation-icons/Contracts/contract6.svg',
  contract_7_icon: 'assets/menu-customisation-icons/Contracts/contract7.svg',
  contract_8_icon: 'assets/menu-customisation-icons/Contracts/contract8.svg',
  contract_9_icon: 'assets/menu-customisation-icons/Contracts/contract9.svg',
};
